<template>
  <div class="p-x-20 p-y-20 menu-link" @click="detail">
    <div class="d-flex-between-center">
      <div class="d-block">
        <div class="f-bold f-16">
          {{ title }}
        </div>
        <div class="f-regular f-14 f-c-midgrey sub-title" v-if="showSubtitle">
          {{ subtitle }}
        </div>
      </div>
      <div class="align-items-center">
        <!-- <img src="../../../assets/icons/chevron-right1.svg" alt=""> -->
        <!-- Copy SVG from "@/assets/icons/chevron-right1.svg" -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 18L15 12L9 6"
            :stroke="`#${iconStroke}`"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SOMenuItemRegular",
  props: {
    title: String,
    subtitle: String,
    showSubtitle: Boolean,
    iconColor: {
      type: String,
      default: "blue", // blue | grey
    },
  },
  computed: {
    iconStroke() {
      return this.iconColor === "blue" ? "4A85FF" : "C8D0DD";
    },
  },
  methods: {
    detail(payload) {
      this.$emit("detail", payload);
    },
  },
};
</script>

<style scoped>
.menu-link {
  background-color: white;
}

.menu-link:active {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
</style>
